'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var index_es$2 = require('../node_modules/slate/dist/index.es.js');
var index_es$1 = require('../node_modules/slate-react/dist/index.es.js');
var index_es = require('../node_modules/slate-history/dist/index.es.js');
var TextEditorContext = require('./TextEditorContext.js');
var ButtonPanel = require('./ButtonPanel.js');
var Input = require('./Input.js');
var styles = require('./styles.js');
var links = require('./plugins/links.js');
var deleteBackwards = require('./plugins/delete-backwards.js');
var Leaf = require('./Leaf.js');
var Element = require('./Element.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TextEditor = _ref => {
  var {
    readOnly = false,
    value,
    onChange,
    // resetOnSave,
    minHeight,
    maxHeight
  } = _ref;
  var classes = styles.useStyles({
    readOnly
  }); // const [value, setValue] = React.useState(getEmptyValue())
  // const [originalValue, setOriginalValue] = React.useState(getEmptyValue())
  // const isDirty = !isEqual(value, originalValue)

  var [isFocused, setIsFocused] = React__default['default'].useState(false);
  var editor = React__default['default'].useMemo(() => links.withLinks(deleteBackwards.withDeleteBackwards(index_es.withHistory(index_es$1.withReact(index_es$2.createEditor())))), []);
  React__default['default'].useEffect(() => {
    if (isFocused) {
      index_es$1.ReactEditor.focus(editor);
      index_es$2.Transforms.move(editor, {
        edge: 'end'
      });
    }
  }, [isFocused, editor]);

  function handleManualFocus() {
    if (!isFocused) {
      setIsFocused(true);
    }
  }

  console.log(editor.selection); // function handleSave() {
  //   onSave?.(value)
  //   if (resetOnSave) {
  //     resetEditor()
  //     setValue(getEmptyValue())
  //   }
  // }

  function handleChange(newValue) {
    onChange(newValue);
  } // React.useEffect(() => {
  //   if (!value) {
  //     resetEditor()
  //   }
  // }, [value])
  // Synchronize the value whenever the props value changes.
  // React.useEffect(() => {
  //   resetEditor()
  //   setValue(valueFromProps || getEmptyValue())
  //   // setOriginalValue(valueFromProps || getEmptyValue())
  // }, [valueFromProps])


  var renderElement = React__default['default'].useCallback(props => /*#__PURE__*/React__default['default'].createElement(Element.Element, props), []);
  var renderLeaf = React__default['default'].useCallback(props => /*#__PURE__*/React__default['default'].createElement(Leaf.Leaf, props), []);
  return /*#__PURE__*/React__default['default'].createElement(TextEditorContext.TextEditorContext.Provider, {
    value: {
      classes,
      setIsFocused,
      isFocused,
      value,
      renderElement,
      renderLeaf
    }
  }, /*#__PURE__*/React__default['default'].createElement(index_es$1.Slate, {
    editor: editor,
    value: value,
    onChange: handleChange
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.editor,
    onClick: handleManualFocus
  }, /*#__PURE__*/React__default['default'].createElement(Input.Input, {
    minHeight: minHeight,
    maxHeight: maxHeight
  }), /*#__PURE__*/React__default['default'].createElement(ButtonPanel.ButtonPanel, null))));
};
TextEditor.propTypes = {
  /** If `true` the content cannot be edited */
  readOnly: index.bool,

  /** The initial JSON value of the content */
  value: index.any,
  title: index.string,

  /**
   * Callback fired when the user wants the content .
   *
   * @param {string} value The JSON representation of the changed content.
   */
  onSave: index.func,
  onChange: index.func,
  saveOnEnter: index.bool,
  variant: index.oneOf(['message', 'post']),
  minHeight: index.number,
  maxHeight: index.number
};

exports.TextEditor = TextEditor;
exports.default = TextEditor;
